const BASE = '/v1/auth'

export const AUTH_ROUTES = {
  LOGIN: `${BASE}/login`,
  LOGOUT: `${BASE}/logout`,
  REFRESH_TOKEN: `${BASE}/refresh-token`,
  RECOVERY: `${BASE}/recovery-password`,
  RESEND_RECOVERY_CODE: `${BASE}/resend-recovery-code`,
  VALIDATE_RECOVERY_CODE: `${BASE}/validate-recovery-code`,
  RESET_PASSWORD: `${BASE}/reset-password`,
} as const
